import { FC, useEffect } from 'react';
import { Grid, Divider } from '@prometheus/components';
import {
  NestedInfoWrapper,
  SecondaryContentWrapper,
  TabsNavigationNew,
  VocabularyManagementBaseInfo,
} from '@prometheus/features';
import { tabs } from './VocabularyManagement.config';

import { Route, Routes } from 'react-router-dom';
import { Bundles } from './Bundles/Bundles';
import { DownloadedBundles } from './DownloadedBundles';
import { useEntityNew } from '@prometheus/hooks';
import {
  getCurrentUserAthenaAuth,
  updateCurrentUserAthenaAuth,
} from '@/api/vocabulary-management';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setBreadcrumbs } from '@prometheus/redux';

export interface VocabularyManagementProps {
  root: any;
}
export const VocabularyManagement: FC<VocabularyManagementProps> = ({
  root,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { entity, updateEntity } = useEntityNew({
    get: getCurrentUserAthenaAuth,
    update: updateCurrentUserAthenaAuth,
  });

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          name: t('breadcrumbs.admin'),
          path: `${root.rootPath}`,
        },
        {
          name: t('breadcrumbs.vocabulary_management'),
          path: `${root.rootPath}/vocabulary`,
        },
      ])
    );
  }, [dispatch]);

  return (
    <Grid container px={6} flexGrow={1} flexDirection="column">
      <NestedInfoWrapper>
        <VocabularyManagementBaseInfo
          entity={entity}
          updateEntity={updateEntity}
        />
      </NestedInfoWrapper>
      <Grid container>
        <Grid item xs={12}>
          <TabsNavigationNew tabs={tabs()} withRouting secondary />
          <Divider />
        </Grid>

        <Grid item xs={12} py={3}>
          <SecondaryContentWrapper>
            <Routes>
              <Route index element={<Bundles />} />
              <Route path="downloaded/*" element={<DownloadedBundles />} />
            </Routes>
          </SecondaryContentWrapper>
        </Grid>
      </Grid>
    </Grid>
  );
};
